import {
  Checkbox,
  FormControl,
  FormControlLabel,
  Stack
} from '@mui/material';
import { VerticleFilterModalLayout } from 'modules/components/layer13';
import React from 'react';
import * as ds from './dataService';


export type FilterTasksModalProps = {
  id: string;
  isVisible: boolean;
  handleClose: () => void;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: FilterTasksModalProps) => {
  const form = ds.useFormState();

  const fieldNames: (keyof typeof form.formState)[] = [
    'newTasks',
    'assigned',
    'overdue',
    'inApproval',
    'completed'
  ];

  return (
    <VerticleFilterModalLayout.FC
      id={props.id}
      isVisible={props.isVisible}
      handleClose={() => props.handleClose()}
      successButton={{
        handleClick: () => {
          console.log(form.formState);
          props.handleClose();
        }
      }}
      cancelButton={{
        handleClick: () => {
          form.dispatch({
            type: 'RESET'
          });
        }
      }}
      title='Display Tasks'
    >
      <Stack
        rowGap='.5rem'
        paddingY='.75rem'
      >
        {fieldNames.map((node, i) => (
          /* eslint-disable-next-line react/jsx-key */
          <FormControl
            key={i}

          >
            <FormControlLabel
              control={(
                <Checkbox
                  checked={form.formState[node]}
                  onClick={() => form.dispatch({
                    type: 'UPDATE',
                    payload: {
                      property: node,
                      value: !form.formState[node]
                    }
                  })}

                />
              )}
              label={form.genFieldProps(node).label}

            >

            </FormControlLabel>

          </FormControl>
        ))}
      </Stack>


    </VerticleFilterModalLayout.FC>



  );
};
